const actionTypes = {
    GET_GROUP_FILTER_SUCCESS: 'GET_GROUP_FILTER_SUCCESS',
};

export default actionTypes;